var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Overlay",class:{ 'Overlay--visible': _vm.visible }},[_c('div',{staticClass:"Overlay__ClickBlokker",on:{"click":_vm.handleClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }